import React from "react"
import { Grid, Button } from "@mui/material"

import  { CategoryButtonStyles } from "./styles/ButtonStyles"

function CategoryButton({ handleCategoryButtonClick, clickedProp, category }) {
    

    return (
        <Grid container>
            <Grid item xs={6} sm={4} align="center">
                <Button
                    variant="outlined"
                    sx={CategoryButtonStyles}
                    onClick={(event) => handleCategoryButtonClick(category)}
                    color={clickedProp ? "secondary" : "primary"}
                >
                    {category}
                </Button>
            </Grid>
        </Grid>
        
    )
}

export default CategoryButton
